import { CompanyModel } from '../../companies/models/company.model';
import { VacancyModel } from '../../vacancies/models/vacancy.model';

export interface EmployeeMatchingResultModel {
  company: CompanyModel;
  reasonCall: ReasonCall;
  vacancy: VacancyModel;
  distanceDetails: DistanceDetails;
  lastAllocations: AllocationMatchingResultModel[];
}

export interface DistanceDetails {
  origin: string;
  destination: string;
  distance_meters: number;
  duration_seconds: number;
  transportCode: string;
}

export interface ReasonCall {
  companyId: string;
  jobTitle: string;
  vacancyCategory: VacancyCategoryEnum;
  score: number;
  createdAt: string | null;
}

export enum VacancyCategoryEnum {
  INTERNAL = 'INTERNAL',
  VDAB = 'VDAB',
  PSEUDO = 'PSEUDO',
  NACE_BELL = 'NACE_BELL',
  DATA_LAKE = 'DATA_LAKE',
}

export interface AllocationMatchingResultModel {
  uuid: string;
  officeCode: string;
  firstContractStartDate: string;
  lastContractEndDate: string;
  employeeName: string;
  position: string;
}
